module.exports = __webpack_public_path__ + "media/images/article/2022_02_a-1870f2de2354d584fb6c6a3fada63b1a.png";